export const newCallFromUser = (message, reducers, data, connection) => {
  const { placeId, pointId, userId, userDevice, details, createdAt } = message.payload;
  const { eventsDispatch } = reducers;
  eventsDispatch({
    type: 'CALL_NEW',
    payload: { placeId, pointId, userId, userDevice, details, createdAt },
  });
};
